import ModalTemplate from "../../components/ModalTemplate/ModalTemplate";
import Input from "../../components/Input/Input";
import TextEditor from "../../components/TextEditor/TextEditor";
import React, {useEffect, useMemo, useState} from "react";
import {useFormik} from "formik";
import Button from "../../components/Button/Button";
import * as yup from "yup";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import CustomerActions from "../../api/CustomerActions";
import {sentIcon} from "../../components/Icon/Icon";

const validationSchema = yup.object({
    subject: yup.string()
        .trim("Subject cannot be empty spaces")
        .required("Subject is required"),
    body: yup.string()
        .trim("Message body cannot be empty spaces")
        .required("Message body is required")
});

const SendModal = ({onClose, id, onSubmit}) => {
    const [selectedValues, setSelectedValues] = useState([]);
    const origin = window.location.origin;

    const formik = useFormik({
        initialValues: {
            customerId: null,
            subject: null,
            body: "",
            forms: []
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            const payload = {
                ...values,
                attachedForms: selectedValues.map(v => v.value)
            };

            CustomerActions.sendMessage(values.customerId, payload, () => {
                onSubmit({
                    customerId: values.customerId,
                    sentForms: payload.attachedForms
                })
            })
        }
    })

    useEffect(() => {
        if(!id) return;

        CustomerActions.getMessage(id, result => formik.setValues(result));
    }, [id]);

    const mappedOptions = useMemo(() => {
        return formik.values.forms.map(item => ({
            value: item.form.id,
            label: item.form.name
        }));
    }, [formik.values.forms]);


    const footerActions = (
        <>
            <Button type="submit" form="customerSentForm" variant="primary">Send</Button>
            <Button type="button" onClick={onClose} variant="secondary">Cancel</Button>
        </>
    );

    const modalTitle = formik.values.customerName ? `Send to: ${formik.values.customerName} ${formik.values.customerSurname}` : "Loading...";

    return(
        <ModalTemplate
            onClose={onClose}
            title={modalTitle}
            icon={sentIcon}
            footerActions={footerActions}
        >
            <form id="customerSentForm" onSubmit={formik.handleSubmit}>
                <Input
                    name="subject"
                    label="Subject"
                    className="modal"
                    required={false}
                    formik={formik}
                />

                <TextEditor
                    value={formik.values.body.replace("website/",`${origin}/`)}
                    onTextChange={(newContent) => formik.setFieldValue("body", newContent)}
                    onBlur={formik.handleBlur}
                    error={formik.touched.body ? formik.errors.body : null}
                />

                <CustomSelect
                    label="Attached forms"
                    options={mappedOptions}
                    value={selectedValues}
                    onChange={setSelectedValues}
                    isMulti={true}
                />

            </form>
        </ModalTemplate>
    )
}

export default SendModal;